export const customProductFilterOption = (option, inputValue) => {
	if (!inputValue) return true;

	const searchText = inputValue.toLowerCase();
	const item = option.data;

	const matchesLabel = item.label?.toLowerCase().includes(searchText);
	const matchesIngredients = item.active_ingredients_list?.some((ingredient) => ingredient.toLowerCase().includes(searchText));

	return matchesLabel || matchesIngredients;
};
